import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { StatusLabelPill } from "./StatusLabelPill";

const CancelledStatusPillStyled = styled(StatusLabelPill)(() => {
  const theme = useTheme();
  return {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  };
});

export const CancelledStatusPill = () => {
  const { t } = useTranslation();
  return <CancelledStatusPillStyled>{t("ShiftTimeline.cancelled")}</CancelledStatusPillStyled>;
};
